import { FC } from 'react';

import { Box, Flex, Hide, StyleProps } from '@bonusly/design-system';

import { CompanyLogo } from './CompanyLogo';
import { ExternalLinks } from './ExternalLinks';
import { GoHomeButton } from './GoHomeButton';
import { useNav } from './hooks/useNav';
import { Nav } from './Nav';
import { ToggleSuperAdminControls } from './ToggleSuperAdminControls';
import { TrialBanner } from './trial-banner';

export const VerticalNavbar: FC<StyleProps> = (props) => {
	const { nav } = useNav();
	return (
		<Hide below="xs">
			<Flex data-testid="vertical-navbar" as="nav" bgColor="bg.surface" flexDirection="column" {...props}>
				<Box borderBottomColor="border.default" borderBottomWidth={1}>
					<CompanyLogo />
					<GoHomeButton />
					<TrialBanner />
				</Box>
				<Box overflowY="auto" px={1}>
					<Nav nav={nav.admin} />
					<ExternalLinks />
					<ToggleSuperAdminControls />
					<Nav nav={nav.superAdmin} />
				</Box>
			</Flex>
		</Hide>
	);
};
